// User menu functionality is now handled inside NavigationSideBar (top nav).
const UserMenu = () => null;
export default UserMenu;
